import _regeneratorRuntime from "/workdir/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/workdir/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function executeHookFunctions(_x) {
  return _executeHookFunctions.apply(this, arguments);
}

function _executeHookFunctions() {
  _executeHookFunctions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(functions) {
    var i;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < functions.length)) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return functions[i]();

          case 4:
            i++;
            _context.next = 1;
            break;

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _executeHookFunctions.apply(this, arguments);
}

function executeHooksBefore(_x2) {
  return _executeHooksBefore.apply(this, arguments);
}

function _executeHooksBefore() {
  _executeHooksBefore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(hook) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!hook || !hook.before || !hook.before.length)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            _context2.next = 4;
            return executeHookFunctions(hook.before);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _executeHooksBefore.apply(this, arguments);
}

function executeHooksAfter(_x3) {
  return _executeHooksAfter.apply(this, arguments);
}

function _executeHooksAfter() {
  _executeHooksAfter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(hook) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(!hook || !hook.after || !hook.after.length)) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return");

          case 2:
            _context3.next = 4;
            return executeHookFunctions(hook.after);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _executeHooksAfter.apply(this, arguments);
}

function mergeHook(hooks, formName, hookToMerge) {
  var existingHook = hooks[formName] = hooks[formName] || {
    before: [],
    after: []
  };

  if (hookToMerge.before) {
    existingHook.before = existingHook.before.concat(hookToMerge.before);
  }

  if (hookToMerge.after) {
    existingHook.after = existingHook.after.concat(hookToMerge.after);
  }
}

export { executeHookFunctions, executeHooksAfter, executeHooksBefore, mergeHook };